import { useQuery } from "@tanstack/react-query";

export interface StatsResponse {
  db: {
    posts_total: number;
    posts_animated_by_ext: Record<string, number>;
    posts_blocked: number;
    posts_deleted: number;
    tags_total: number;
    aliases_total: number;
    implications_total: number;
  };
  sync: {
    last_dump_date: string | null;
    last_full_run: string | null;
    auto_sync_enabled: boolean;
    next_scheduled_at: string | null;
  };
  downloads: {
    jobs_by_status: Record<string, number>;
    jobs_by_preset_done: Record<string, number>;
  };
  disk: {
    downloads_dir: string;
    breakdown: Record<string, { files: number; bytes: number }>;
    total_files: number;
    total_bytes: number;
  };
  media_cache: {
    hits: number;
    misses: number;
    hit_ratio: number | null;
  };
  geo_enabled: boolean;
}

async function fetchStats(): Promise<StatsResponse> {
  const res = await fetch("/api/v1/admin/stats", {
    credentials: "same-origin",
  });
  if (!res.ok) {
    throw new Error(`stats fetch failed: ${res.status}`);
  }
  return res.json();
}

export function useStats() {
  return useQuery<StatsResponse>({
    queryKey: ["admin", "stats"],
    queryFn: fetchStats,
    // Disk stats are cached server-side for 60s; matching that here.
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
